import React, { useState } from 'react';
import { Header } from './Header';
import { Problem } from './Problem';
import { ProblemDeepening } from './ProblemDeepening';
import { Agitation } from './Agitation';
import { Solution } from './Solution';
import { SocialProof } from './SocialProof';
import { MethodDetails } from './MethodDetails';
import { Guarantee } from './Guarantee';
import { Urgency } from './Urgency';
import { CallToAction } from './CallToAction';
import { TwoPaths } from './TwoPaths';
import { Footer } from './Footer';
export const Advertorial = () => {
  const openModal = () => {
    window.location.href = 'https://training.stresslessdogs.nl/va-video';
  };
  return <div className="max-w-3xl mx-auto px-4 py-6 font-sans text-gray-800" data-id="element-7">
      <Header openModal={openModal} data-id="element-8" />
      <Problem openModal={openModal} data-id="element-9" />
      <ProblemDeepening openModal={openModal} data-id="element-10" />
      <Agitation openModal={openModal} data-id="element-11" />
      <Solution openModal={openModal} data-id="element-12" />
      <SocialProof data-id="element-13" />
      <MethodDetails openModal={openModal} data-id="element-14" />
      <Guarantee data-id="element-15" />
      <Urgency openModal={openModal} data-id="element-16" />
      <CallToAction openModal={openModal} data-id="element-17" />
      <TwoPaths openModal={openModal} data-id="element-18" />
      <Footer data-id="element-19" />
    </div>;
};